var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { ref: "container", staticClass: "video-embed" }, [
    _c(
      "div",
      { staticClass: "video-embed__aspect-ratio", style: _vm.aspectRatioStyle },
      [
        _vm.video
          ? _c(
              "iframe",
              _vm._b(
                {
                  ref: "videoFrame",
                  staticClass: "video-embed__iframe",
                  attrs: { id: _vm.videoIframeId },
                },
                "iframe",
                _vm.backgroundVideoAttrs,
                false
              )
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }